export const SEARCH = '/search';
export const CATEGORY = '/category';
